import { createAction } from 'redux-actions';

import { AUTOSAVED_DRAFT_TYPES } from '../../util/autosaved-draft-types';

const clearSuccess = createAction('CLEAR_DRAFT_SUCCESS');
export const clearAutosavedDraft =
  (type: ValueOf<typeof AUTOSAVED_DRAFT_TYPES>, context: AutosaveContext) =>
  (dispatch: Function) => {
    dispatch(
      clearSuccess({
        type,
        context,
      }),
    );
  };
